import { Clock, CrossRounded, Dots, Success } from '@app/icons'
import styles from './contractState.module.scss'
import React from 'react'
import { SuccessMark, WorkerDots } from '@app/images'

export const ContractState = ({ state, lang }) => {
	const icons = {
		1: <Success className={styles.iconSuccess} />,
		2: <Clock className={styles.iconClock} />,
		3: <Dots className={styles.iconClock} />,
		4: <Dots className={styles.iconClock} />,
		5: <Dots className={styles.iconClock} />,
		6: <CrossRounded className={styles.iconClock} />,
		7: <Dots className={styles.iconClock} />,
		8: <CrossRounded className={styles.iconClock} />,
		9: <CrossRounded className={styles.iconClock} />,
		10: <CrossRounded className={styles.iconClock} />,
		11: <CrossRounded className={styles.iconClock} />,
		12: <CrossRounded className={styles.iconClock} />,
		13: <Dots className={styles.iconClock} />,
		15: <CrossRounded className={styles.iconClock} />,
		16: <Dots className={styles.iconClock} />,
		20: <Success className={styles.iconSuccess} />,
	}

	const classes = {
		1: styles.textSuccess,
		2: styles.textClock,
		3: styles.textClock,
		4: styles.textClock,
		5: styles.textClock,
		6: styles.textRed,
		7: styles.textClock,
		8: styles.textRed,
		9: styles.textRed,
		10: styles.textRed,
		11: styles.textRed,
		12: styles.textRed,
		13: styles.textClock,
		15: styles.textRed,
		16: styles.textClock,
		20: styles.textSuccess,
	}

	return (
		<div className={styles.contractState}>
			<div>{icons[state.code || 1] || <Dots className={styles.iconClock} />}</div>
			{
				<span className={classes[state.code || 1] || styles.textClock}>
					{state[lang === 'rus' ? 'nameRu' : 'nameKz'] || 'Подписан'}
				</span>
			}
		</div>
	)
}
